import React from 'react';
import { cn } from '@/utils';

export const LoadingBar = ({ className }: { className?: string }) => {
  return (
    <div
      className={cn(
        'h-6 bg-gray-700 w-full rounded-md animate-gradient-background',
        className,
      )}
      style={{
        background:
          'linear-gradient(to right, #353535 40%, #545454 50%, #353535 60%)',
        backgroundSize: '260%',
      }}
    ></div>
  );
};
